/* eslint-disable no-unused-vars */

export enum userManageConstant {
  FETCH_LIST_USER = 'FETCH_LIST_USER',
  UPDATE_LIST_USER = 'UPDATE_LIST_USER',
  UPDATE_LIST_ROLES = 'UPDATE_LIST_ROLES',
  UPDATE_USER = 'UPDATE_USER',
  SELECT_RECORD = 'SELECT_RECORD',
  EDIT_USER = 'EDIT_USER',
  CREATE_USER = 'CREATE_USER',
  RESEND_INVITE_EMAIL = 'RESEND_INVITE_EMAIL',
  DELETE_USER = 'DELETE_USER',
  GET_LIST_ROLE = 'GET_LIST_ROLE',
  CHANGE_PW = 'CHANGE_PW',
  UPDATE_STATE_CHANGE_PW = 'UPDATE_STATE_CHANGE_PW',
  UPDATE_STATE_FORGOT_PW = 'UPDATE_STATE_FORGOT_PW ',
}
